import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import markItemsJunkNotJunkBasedOnItemIds from './markItemsJunkNotJunkBasedOnItemIds';
import { actionNames } from 'owa-mail-store-actions';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
/**
 * The action which marks conversations as junk.
 * @param conversationRowKeys - the conversations rows to mark as junk
 * @param tableView - the table view the conversations are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - the source that initiated the action call
 */
export default function markConversationsJunkNotJunkFromTable(conversationRowKeys, tableView, isJunkValueToSet, actionSource) {
    // the itemIds need to be retrieved before the store update, otherwise it might get removed
    var itemIdsToUpdate = getItemIdsFromConversations(conversationRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView(conversationRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds(itemIdsToUpdate, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        // remove conversation from list view and reading pane store
        var conversationIds = getRowIdsFromRowKeys(conversationRowKeys, tableView.id);
        raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIds, tableView);
    });
}
//# sourceMappingURL=markConversationsJunkNotJunkFromTable.js.map